import { Controller } from 'stimulus'
import { trackEvent } from '../../src/javascripts/tracking'

/*
Why listen to window "message" (hsFormCallback) instead of "hs-form-event:on-submission:success"?

- HubSpot’s global CustomEvents only fire if listeners are attached before hbspt.forms.create runs.
  With Prismic slices, the embed script can execute before this Stimulus controller connects,
  so those events can be missed.
- Modifying slice markup to inject callbacks isn’t scalable across pages.
- The embed iframe consistently posts window messages of type "hsFormCallback" with eventName
  "onFormReady" and "onFormSubmit" (or "onFormSubmitted"), so we listen for those and handle both
  object and JSON-string payloads.
- To avoid duplicate analytics during rapid multi-fires from the embed, we dedupe by firing once per page load.
*/

export default class extends Controller {
  static values = { name: String, currency: String, price: Number }

  connect() {
    if (this.hasNameValue && this.hasCurrencyValue && this.hasPriceValue) {
      this._fired = false

      this._onMessage = (event) => {
        if (this._fired) return

        let data = event.data
        if (typeof data === 'string') {
          try { data = JSON.parse(data) } catch { return }
        }
        if (!data || data.type !== 'hsFormCallback') return

        if (data.eventName === 'onFormSubmit' || data.eventName === 'onFormSubmitted') {
          this.submittedForm()
          this._fired = true
          window.removeEventListener('message', this._onMessage)
          this._onMessage = null
        }
      }

      window.addEventListener('message', this._onMessage, { passive: true })
    }
  }

  disconnect() {
    if (this._onMessage) {
      window.removeEventListener('message', this._onMessage)
      this._onMessage = null
    }
  }

  submittedForm() {
    trackEvent(
      this.nameValue,
      {
        currency: this.currencyValue,
        value: this.priceValue
      }
    )
  }
}
